import supabaseClient from '@/api/supabaseClient';
import { useMutation } from '@tanstack/react-query';
import type { UpdateItineraryDayPayload } from '$/requests/UpdateItineraryDayRequest.ts';
import { queryClient } from '@/main.tsx';
import invokeRefinement from '@/api/itineraries/invokeRefinement.ts';

const useUpdateItineraryDay = () =>
  useMutation({
    mutationFn: (request: UpdateItineraryDayPayload) =>
      invokeRefinement(supabaseClient, 'update_itinerary_day', request),
    retry: false,
    onSuccess: (result) => {
      if (result.outcome !== 'changed') return;

      void queryClient.invalidateQueries({ queryKey: ['itineraries'] });
      void queryClient.invalidateQueries({ queryKey: ['places'] });
    },
  });

export default useUpdateItineraryDay;
